import { DOBSelect, GradYears, Height } from "../Athletes/Options";
import React from "react";

import FormDropdown from "../Dropdown";
import SchoolSelect from "../Athletes/SchoolSelect";

const ConfirmData = ({
	gradYear,
	setGradYear,
	school,
	setSchool,
	day,
	setDay,
	month,
	setMonth,
	year,
	setYear,
	feet,
	setFeet,
	inches,
	setInches,
	season,
	shirtSize,
	setShirtSize,
	shortSize,
	setShortSize,
	practiceTeams,
	isPracticeTeam,
	setIsPracticeTeam,
}) => {
	const labelClass =
		"text-xs font-bold uppercase tracking-[0.12em] text-slate-400";

	return (
		<div className="grid gap-4 rounded-md border border-white/10 bg-black/20 p-4">
			<div className="grid gap-1">
				<h4 className="m-0 text-base font-bold text-white">
					Confirm Athlete Data
				</h4>
				<p className="m-0 text-sm text-slate-400">
					Review the athlete details before completing registration.
				</p>
			</div>

			{/* School Info */}
			<div className="grid gap-3 md:grid-cols-[2fr_1fr]">
				{/* School Select */}
				<div className="grid gap-1.5">
					<small className={labelClass}>Current School</small>
					<SchoolSelect defaultValue={school} setSchool={setSchool} />
				</div>

				{/* Grad Year Select */}
				<div className="grid gap-1.5 md:max-w-[11rem]">
					<small className={labelClass}>HS Grad Year</small>
					<FormDropdown
						options={GradYears}
						value={gradYear}
						setVal={setGradYear}
					/>
				</div>
			</div>

			{/* Date of Birth */}
			<div className="grid gap-1.5">
				<small className={labelClass}>Date of Birth</small>
				<DOBSelect
					day={day}
					setDay={setDay}
					month={month}
					setMonth={setMonth}
					year={year}
					setYear={setYear}
				/>
			</div>

			{/* Height */}
			<div className="grid gap-1.5">
				<small className={labelClass}>Height</small>
				<Height
					feet={feet}
					setFeet={setFeet}
					inches={inches}
					setInches={setInches}
				/>
			</div>

			{/* Clothing Sizing */}
			<div className="flex flex-wrap gap-3">
				{/* Shirt Select */}
				<div className="grid w-32 gap-1.5">
					<small className={labelClass}>Shirt Size</small>
					<FormDropdown
						options={["Shirt Size", "S", "M", "L", "XL", "2XL"]}
						value={shirtSize}
						setVal={setShirtSize}
					/>
				</div>
				{/* Shorts Select */}
				<div className="grid w-44 gap-1.5">
					<small className={labelClass}>
						{season === "Girls" ? "Spandex/Legging Size" : "Shorts Size"}
					</small>
					<FormDropdown
						options={["Shorts Size", "S", "M", "L", "XL", "2XL"]}
						value={shortSize}
						setVal={setShortSize}
					/>
				</div>
			</div>

			{practiceTeams ? (
				<div className="grid gap-3 rounded-md border border-white/10 bg-white/[0.04] p-3">
					<div className="grid gap-1">
						<h4 className="m-0 text-sm font-bold text-white">
							Travel Team or Practice Team?
						</h4>
						<p className="m-0 text-sm text-slate-400">
							Only select travel team if you know you can commit to making all
							travel tournaments. Athletes who do not make a travel team will
							still be placed on a practice team roster.
						</p>
					</div>
					<div className="grid gap-3 md:grid-cols-2">
						<label
							className={`flex min-h-[46px] cursor-pointer items-center gap-3 rounded-md border px-4 py-3 text-sm font-bold transition ${
								isPracticeTeam === false
									? "border-accent-color-2 bg-[rgba(108,207,246,0.12)] text-white"
									: "border-white/10 bg-black/20 text-slate-300 hover:border-accent-color-2 hover:text-white"
							}`}
						>
							<input
								type="radio"
								name="react-tips"
								value="option1"
								checked={isPracticeTeam === false}
								onChange={() => setIsPracticeTeam(false)}
								className="form-check-input"
							/>
							Travel Team Tryout
						</label>

						<label
							className={`flex min-h-[46px] cursor-pointer items-center gap-3 rounded-md border px-4 py-3 text-sm font-bold transition ${
								isPracticeTeam === true
									? "border-accent-color-2 bg-[rgba(108,207,246,0.12)] text-white"
									: "border-white/10 bg-black/20 text-slate-300 hover:border-accent-color-2 hover:text-white"
							}`}
						>
							<input
								type="radio"
								name="react-tips"
								value="option2"
								checked={isPracticeTeam === true}
								onChange={() => setIsPracticeTeam(true)}
								className="form-check-input"
							/>
							Practice Team Tryout
						</label>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default ConfirmData;
